import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

import { DoctorContext } from "../../../../stores/Doctor/doctor.provider";
import { UserContext } from "../../../../stores/User/User.provider";
import useStore from "../../../../helpers/useStore";

import { rxuseForm } from "../../../PatientDataEntryForm/Form";

import Private from "./Private/Private";
import { useMasterTables } from "../../../../stores/MasterTables";
import { PatientDto, RxDto } from "../../../../api-client";
import notificationStore from "../../../../stores/Notification/notificationStore";

import RxPage from "../../../RxPage";
import BG from "./BG/BG";
import Verordnung13 from "./Kasse/Verordnung13";
import { observer } from "mobx-react";
import Bundeswehr from "./Bundeswehr/Bundeswehr";
import Zahnarzt from "./Zahnarzt/Zahnarzt";
import Blankoverordnung from "./Blankoverordnung/Blankoverordnung";
import DoctorClinicJoinConfirmDialog from "../../../DoctorManagement/DoctorClinicJoinConfirmDialog";
import DoctorClinicMismatchDialog from "../../../DoctorManagement/DoctorClinicMismatchDialog";
import { useRx } from "../../../../stores/Rx/rx.queries";
import { usePatient } from "../../../../stores/Patients/patient.queries";

interface RxFormsProps {
  isEditing?: boolean;
  readOnlyView?: boolean;
  openRx?: boolean;
  onCloseRx?: any;
  onRxSave?: (rxId: string) => void;
  useDialog?: boolean;
  selectedRxId?: string;
  selectedPatientId?: number;
}
interface DiagnoseGroup {
  a: string;
  b: string;
  c: string;
  d: string;
}

const RxFormsData: React.FC<RxFormsProps> = observer(
  ({
    isEditing,
    readOnlyView,
    openRx,
    onCloseRx,
    onRxSave,
    useDialog,
    selectedPatientId,
    selectedRxId,
  }) => {
    const DoctorStore = useStore(DoctorContext);
    const UserStore = useStore(UserContext);
    const { user } = UserStore;
    const { data: masterTablesData } = useMasterTables();
    // Fetch RX data using the rxId from store
    const {
      data: rowData,
      isLoading: isRxLoading,
      error: rxError,
    } = useRx(selectedRxId!);

    // Get patient data from store
    const { data: patientValues } = usePatient(selectedPatientId!);
    const rxType = (masterTablesData || [])
      .filter((obj: any) => "rxType" in obj) // Filter objects that have the insuranceStatus property
      .map((obj: any) => obj.rxType);

    const rxtype =
      rxType[0].find((option: any) => option.id === rowData?.rxtype?.id)
        ?.text || rowData?.rxtype?.text;

    const renderRxComponent = () => {
      switch (rxtype) {
        case "Privat/Selbstzahler":
          return (
            <Private
              selectedRxId={selectedRxId}
              patientId={selectedPatientId}
              openRx={openRx as boolean}
              onCloseRx={onCloseRx}
            />
          );
        case "Berufsgenossenschaft":
          return (
            <BG
              selectedRxId={selectedRxId}
              patientId={selectedPatientId}
              // setUnsavedChanges={setUnsavedChanges}
              openRx={openRx as boolean}
              onCloseRx={onCloseRx}
            />
          );
        case "Bundeswehr":
          return (
            <Bundeswehr
              selectedRxId={selectedRxId}
              patientId={selectedPatientId}
              openRx={openRx as boolean}
              onCloseRx={onCloseRx}
              // ref={saveGenericViewData}
            />
          );
        case "Kasse":
        case "Entlassmanagement":
          return (
            <Verordnung13
              selectedRxId={selectedRxId}
              patientId={selectedPatientId}
              // setUnsavedChanges={setUnsavedChanges}
              openRx={openRx as boolean}
              onCloseRx={onCloseRx}
              onRxSave={onRxSave}
              // ref={saveGenericViewData}
            />
          );
        case "Blankoverordnung":
          return (
            <Blankoverordnung
              selectedRxId={selectedRxId}
              patientId={selectedPatientId}
              // setUnsavedChanges={setUnsavedChanges}
              openRx={openRx as boolean}
              onCloseRx={onCloseRx}
              // ref={saveGenericViewData}
            />
          );
        case "Zahnarzt":
          return (
            <Zahnarzt
              selectedRxId={selectedRxId}
              patientId={selectedPatientId}
              // setUnsavedChanges={setUnsavedChanges}
              openRx={openRx as boolean}
              onCloseRx={onCloseRx}
              onRxSave={onRxSave}
              // ref={saveGenericViewData}
            />
          );
        // Add other cases for different rxtypes as needed
        default:
          return (
            <RxPage
              isEditing={true}
              patientId={selectedPatientId}
              selectedRxId={selectedRxId}
              // setUnsavedChanges={setUnsavedChanges}
              readOnlyView={readOnlyView}
              openRx={openRx}
              onCloseRx={onCloseRx}
              useDialog={true}
            />
          );
      }
    };

    return (
      <>
        {renderRxComponent()}
        <DoctorClinicJoinConfirmDialog />
        <DoctorClinicMismatchDialog />
      </>
    );
  }
);

export default RxFormsData;
